module.exports = __webpack_public_path__ + "static/icons/icon-arrow-up-7f7c28dde7f989403cde1912e5412152.svg";